import { render, staticRenderFns } from "./EditorError.vue?vue&type=template&id=3e578b6d&scoped=true&"
import script from "./EditorError.vue?vue&type=script&lang=js&"
export * from "./EditorError.vue?vue&type=script&lang=js&"
import style0 from "./EditorError.vue?vue&type=style&index=0&id=3e578b6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e578b6d",
  null
  
)

export default component.exports